import Url, { url } from "src/consts/urlPaths";

interface AiDashboardPathArgs {
  dashboardId: string;
  format?: string | null;
  chatId?: string | null;
  workspaceId?: string | null;
}

/**
 * liquid-v1 (dynamic) → /dashboards/v2/:id
 * regular v1 → /dashboards/:chatId/:id
 * Returns null when a v1 dashboard has no chatId — callers must not navigate
 * (legacy route requires chatId; v2 is the wrong page for v1 content).
 */
export const resolveAiDashboardPath = ({
  dashboardId,
  format,
  chatId,
  workspaceId,
}: AiDashboardPathArgs): string | null => {
  if (format === "liquid-v1") {
    return url(Url.AI_DASHBOARDS_V2, { dashboardId, workspaceId });
  }
  if (!chatId) {
    return null;
  }
  return url(Url.AI_DASHBOARDS, { chatId, dashboardId, workspaceId });
};
